export const services = [
  {
    id: 1,
    icon: "ri-file-list-3-line",
    title: "Asesoría Fiscal",
    description: "Optimizamos tu carga tributaria con declaraciones precisas, planificación fiscal avanzada y representación ante la Agencia Tributaria. Minimizamos riesgos y maximizamos deducciones legales.",
    features: ["Declaración de la Renta (IRPF)", "IVA trimestral y anual", "Impuesto de Sociedades", "Planificación fiscal estratégica", "Inspecciones y recursos fiscales"],
    color: "#6B7F5C",
    image: "https://public.readdy.ai/ai/img_res/67f8aebb11e3834ccf8f3e38206e950d.jpg",
    advisor: {
      name: "Pasqual Vidal Ferrer",
      role: "Asesor Fiscal",
      photo: "https://storage.readdy-site.link/project_files/db85668d-0973-4f5a-ac63-8b47d247ab38/cb81e2b9-c94f-4037-a957-2be9af3f1eb9_Pasqual-Vidal-Ferrer.png?v=efa92c2437edb26c5b85851d36d4cd0a",
    },
  },
  {
    id: 2,
    icon: "ri-briefcase-4-line",
    title: "Asesoría Laboral",
    description: "Gestionamos todo el ámbito laboral de tu empresa: contratos, nóminas, despidos y relaciones con la Seguridad Social. Cumplimiento normativo garantizado.",
    features: ["Contratos y convenios colectivos", "Nóminas y seguros sociales", "Expedientes de regulación (EREs/ERTEs)", "Asesoramiento en despidos", "Auditorías laborales"],
    color: "#8B9E7A",
    image: "https://readdy.ai/api/search-image?query=business%20meeting%20professional%20HR%20team%20reviewing%20labor%20contracts%20modern%20bright%20office%20minimalist%20design%20neutral%20tones%20warm%20light%20businesspeople%20documents%20table&width=600&height=400&seq=s2&orientation=landscape",
    advisor: {
      name: "Anna Vidal Ferrer",
      role: "Asesora Laboral",
      photo: "https://storage.readdy-site.link/project_files/db85668d-0973-4f5a-ac63-8b47d247ab38/ebdcf704-343e-4355-bc5e-f3b64e76d45d_Anna-Vidal-Ferrer.png?v=39b0d1f9b4bdd55b79555b0bd8389133",
    },
  },
  {
    id: 3,
    icon: "ri-shield-check-line",
    title: "Seguros Empresariales",
    description: "Analizamos tus necesidades y diseñamos una cobertura integral para proteger tu negocio, empleados y patrimonio frente a cualquier contingencia. Especialistas en seguros agrícolas para la Marina Alta.",
    features: ["Seguros de responsabilidad civil", "Seguros de vida y accidentes", "Seguros agrícolas (heladas, pedrisco)", "Seguros de negocio e incendios", "Seguro de crédito y caución"],
    color: "#A0B08E",
    image: "https://readdy.ai/api/search-image?query=insurance%20protection%20shield%20concept%20professional%20advisor%20consulting%20client%20modern%20office%20clean%20minimal%20background%20trust%20safety%20business%20security%20warm%20neutral%20tones&width=600&height=400&seq=s3&orientation=landscape",
    advisor: {
      name: "Marilo Ferrer Bay",
      role: "Responsable de Seguros",
      photo: "https://storage.readdy-site.link/project_files/db85668d-0973-4f5a-ac63-8b47d247ab38/98c58b97-d4df-49bd-921a-1634c2b0a56c_Marilo-Ferrer-Bay.png?v=c9ee71734bef37513bc16dae81216a43",
    },
  },
  {
    id: 4,
    icon: "ri-building-2-line",
    title: "Constitución de Empresas",
    description: "Te acompañamos en cada paso de la creación de tu empresa: elección de la forma jurídica, trámites notariales, registros e inscripciones oficiales.",
    features: ["Elección de forma jurídica", "Constitución de SL y SA", "Trámites en Registro Mercantil", "Alta en Hacienda y S. Social", "Estatutos y actas fundacionales"],
    color: "#6B7F5C",
    image: "https://readdy.ai/api/search-image?query=business%20startup%20company%20formation%20signing%20documents%20notary%20office%20professional%20modern%20interior%20clean%20desk%20fountain%20pen%20premium%20paper%20elegant%20neutral%20background&width=600&height=400&seq=s4&orientation=landscape",
    advisor: {
      name: "Pasqual Vidal Ferrer",
      role: "Asesor Fiscal",
      photo: "https://storage.readdy-site.link/project_files/db85668d-0973-4f5a-ac63-8b47d247ab38/cb81e2b9-c94f-4037-a957-2be9af3f1eb9_Pasqual-Vidal-Ferrer.png?v=efa92c2437edb26c5b85851d36d4cd0a",
    },
  },
  {
    id: 5,
    icon: "ri-exchange-funds-line",
    title: "Contabilidad y Finanzas",
    description: "Llevamos tu contabilidad al día con informes claros, balance de situación y cuenta de resultados para que tomes decisiones con información fiable y sin sorpresas.",
    features: ["Contabilidad general y analítica", "Cierres contables anuales", "Informes financieros mensuales", "Control de tesorería", "Conciliaciones bancarias"],
    color: "#8B9E7A",
    image: "https://readdy.ai/api/search-image?query=accounting%20finance%20spreadsheets%20graphs%20charts%20modern%20office%20professional%20setup%20clean%20desk%20laptop%20financial%20reports%20minimalist%20warm%20neutral%20background%20business%20analytics&width=600&height=400&seq=s5&orientation=landscape",
    advisor: {
      name: "Anna Vidal Ferrer",
      role: "Asesora Contable",
      photo: "https://storage.readdy-site.link/project_files/db85668d-0973-4f5a-ac63-8b47d247ab38/ebdcf704-343e-4355-bc5e-f3b64e76d45d_Anna-Vidal-Ferrer.png?v=39b0d1f9b4bdd55b79555b0bd8389133",
    },
  },
  {
    id: 6,
    icon: "ri-customer-service-2-line",
    title: "Consultoría de Gestión",
    description: "Optimizamos los procesos de tu empresa para mejorar su rentabilidad. Análisis estratégico, mejora de procesos y planificación a largo plazo con base en datos contables reales.",
    features: ["Análisis DAFO empresarial", "Planificación estratégica", "Mejora de procesos internos", "Control de gestión (KPIs)", "Financiación y subvenciones"],
    color: "#A0B08E",
    image: "https://readdy.ai/api/search-image?query=business%20strategy%20consulting%20whiteboard%20planning%20team%20discussion%20modern%20bright%20meeting%20room%20professional%20minimalist%20design%20neutral%20walls%20natural%20light%20growth%20charts&width=600&height=400&seq=s6&orientation=landscape",
    advisor: {
      name: "Anna Vidal Ferrer",
      role: "Asesora Contable",
      photo: "https://storage.readdy-site.link/project_files/db85668d-0973-4f5a-ac63-8b47d247ab38/ebdcf704-343e-4355-bc5e-f3b64e76d45d_Anna-Vidal-Ferrer.png?v=39b0d1f9b4bdd55b79555b0bd8389133",
    },
  },
];
